import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import {
  listenToShortGuestReservations,
  upsertShortstayReservation,
} from "../../../../redux/shortstayReservationSlice";

const GuestShortenShortstay: React.FC = () => {
  const { guestId, listingId, reservationId, checkIn, checkOut } = useParams<{
    guestId: string;
    listingId: string;
    reservationId: string;
    checkIn: string;
    checkOut: string;
  }>();

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const reservations = useSelector(
    (state: RootState) => state.shortstayReservations.guestReservations
  );
  const booking = reservations.find(res => res.id === reservationId);

  const [modalOpen, setModalOpen] = useState(false);
  const [confirming, setConfirming] = useState(false);

  useEffect(() => {
    if (guestId) dispatch(listenToShortGuestReservations(guestId));
  }, [dispatch, guestId]);

  const handleConfirm = async () => {
    if (!booking?.id || !checkIn || !checkOut) return;

    setConfirming(true);

    await dispatch(
      upsertShortstayReservation({
      paymentId: booking.paymentId,   // ✅ required by the slice
        updates: {
          checkIn,
          checkOut,
        },
      })
    );

    setTimeout(() => {
      navigate(`/shortbookings/${guestId}`);
    }, 1000);
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.title}>Shorten Reservation</h2>

      <div style={styles.card}>
        <h3 style={styles.subTitle}>Current Booking</h3>
        <p><strong>Check-In:</strong> {booking?.checkIn}</p>
        <p><strong>Check-Out:</strong> {booking?.checkOut}</p>
        <p><strong>Status:</strong> {booking?.reservationStatus}</p>

        <hr style={styles.hr} />

        <p><strong>New Check-Out:</strong> {checkOut}</p>
        <p style={{ color: "#ccc", marginTop: 10 }}>
          This will update your reservation and reduce your stay. Refunds will be processed if applicable.
        </p>

        <button onClick={() => setModalOpen(true)} style={styles.confirmBtn}>
          Confirm Shorten
        </button>
      </div>

      {modalOpen && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <h4>Confirm Shortening?</h4>
            <p>This will update your reservation and shorten your stay.</p>
            <button
              onClick={handleConfirm}
              disabled={confirming}
              style={styles.modalBtn}
            >
              {confirming ? "Updating..." : "Yes, Confirm"}
            </button>
            <button onClick={() => setModalOpen(false)} style={styles.cancelBtn}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GuestShortenShortstay;

const styles: { [key: string]: React.CSSProperties } = {
  page: {
    background: "#000",
    color: "#fff",
    minHeight: "100vh",
    padding: "80px 20px 140px",
    fontFamily: "sans-serif",
  },
  title: {
    fontSize: "1.8rem",
    textAlign: "center",
    marginBottom: 20,
  },
  card: {
    background: "#111",
    borderRadius: 16,
    padding: 24,
    maxWidth: 500,
    margin: "0 auto",
    border: "1px solid #bf9b30",
  },
  subTitle: {
    fontSize: "1.2rem",
    marginBottom: 10,
  },
  hr: {
    border: "none",
    borderTop: "1px solid #333",
    margin: "16px 0",
  },
  confirmBtn: {
    marginTop: 20,
    padding: "12px 20px",
    borderRadius: 30,
    border: "none",
    fontWeight: 600,
    fontSize: 16,
    background: "orange",
    color: "#000",
    cursor: "pointer",
    width: "100%",
  },
  modal: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  },
  modalContent: {
    background: "#222",
    padding: 24,
    borderRadius: 12,
    width: "90%",
    maxWidth: 400,
    textAlign: "center",
    border: "1px solid #bf9b30",
  },
  modalBtn: {
    marginTop: 16,
    padding: "10px 20px",
    borderRadius: 30,
    border: "none",
    fontWeight: 600,
    background: "orange",
    color: "#000",
    cursor: "pointer",
    width: "100%",
  },
  cancelBtn: {
    marginTop: 10,
    padding: "10px 20px",
    borderRadius: 30,
    border: "1px solid #444",
    background: "#111",
    color: "#ccc",
    cursor: "pointer",
    width: "100%",
  },
};